import * as THREE from 'three';
import { jsondan } from '../FikoThreeType';
import { Fiko3DYaziIsaretleyici } from './Fiko3DYaziIsaretleyici';
import { FikoGrup } from './FikoGrup';
import { FikoIsikOrtam } from './FikoIsikOrtam';
import { FikoIsikYonsel } from './FikoIsikYonsel';
import { FikoSahne } from './FikoSahne';
import { FikoOperasyon } from './FikoThreeCam/Fikoperasyon';
import { FikoOperasyonlar } from './FikoThreeCam/Fikoperasyonlar';


export class FikoIsiklar extends FikoGrup {
    override type: any = "FikoIsiklar";
    /** */
    sayac = 1;

    sagButonlar = [
        {
            isim: "Ortam Işığı Ekle",
            simge: "lightbulb outline",
            tiklandi: () => {
                this.ekleFikoOrtamIsik();
            }
        },
        {
            isim: "Yönsel Işık Ekle",
            simge: "lightbulb",
            tiklandi: () => {
                this.ekleFikoYonselIsik();
            }
        }
    ]

    public override get liste(): FikoIsikOrtam[] | FikoIsikYonsel[] {
        return this.children as any;
    }

    constructor(public override sahne?: FikoSahne, name?: string) {
        super(sahne);
        this.name = name;
        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = false;
        this.userData['FikoArayuz'].simge = "./simgeler/lamba.webp";
    }

    ekleFikoOrtamIsik(isim?: string): FikoIsikOrtam {
        let ekl = new FikoIsikOrtam(this.sahne, isim ? isim : 'Fiko Ortam Işığı.' + this.sayac);
        ekl.name = isim ? isim : 'Fiko Ortam Işığı.' + this.sayac;
        this.sayac += 1;

        return this.ekle(ekl) as any;
    }

    ekleFikoYonselIsik(isim?: string): FikoIsikOrtam {
        let ekl = new FikoIsikYonsel(this.sahne, isim ? isim : 'Fiko Yönsel Işık.' + this.sayac);
        ekl.name = isim ? isim : 'Fiko Yönsel Işık.' + this.sayac;
        this.sayac += 1;

        return this.ekle(ekl) as any;
    }


    // override toJSON(meta?: { geometries: any; materials: any; textures: any; images: any }): any {
    //     const _rslt: any = { type: this.type, isim: this.name, uuid: this.uuid } // super.toJSON(meta);

    //     const childs: any[] = []
    //     for (let index = 0; index < this.children.length; index++) {
    //         const element = this.children[index];

    //         childs.push(element.toJSON());
    //     }
    //     _rslt.operasyonlar = childs;

    //     return _rslt;
    // }

    // static fromJson(sahne?: FikoSahne, parent?: any, json?: any) {
    //     const _rslt = new FikoOperasyonlar(sahne, json.isim);
    //     _rslt.uuid = json.uuid;

    //     _rslt.parent = parent;

    //     for (let i = 0; i < json.operasyonlar.length; i++) {
    //         let element = json.operasyonlar[i];
    //         _rslt.children[i] = jsondan(sahne, _rslt, element);
    //     }


    //     return _rslt;
    // }

    // toStr() {
    //     let _rslt = `{ "uuid":"${this.uuid}","ismi": "${this.name}","type":"${this.type}","children":[`;
    //     for (let i = 0; i < this.liste.length; i++) {
    //         const element = this.liste[i];
    //         if (i > 0) _rslt += `,`
    //         _rslt += element.toStr();
    //     }
    //     _rslt += `] }`;
    //     return _rslt;
    // }

}